import styled from 'styled-components'
import tw from 'twin.macro'

export const Container = styled.div``
